const UTMIFY_SCRIPT_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'

/**
 * Carga el script oficial de UTMify (captura y persistencia de parámetros UTM).
 * Es idempotente: si el script ya fue inyectado, no vuelve a añadirlo.
 */
export function loadUtmify(): void {
  if (typeof document === 'undefined') return
  if (document.querySelector(`script[src="${UTMIFY_SCRIPT_SRC}"]`)) return

  const script = document.createElement('script')
  script.src = UTMIFY_SCRIPT_SRC
  script.async = true
  script.defer = true
  script.setAttribute('data-utmify-prevent-xcod-sck', '')
  script.setAttribute('data-utmify-prevent-subid', '')

  document.head.appendChild(script)
}
